<div
  class="tabs"
  [ngClass]="{
    'tabs--small': tabSize == 'small',
    'tabs--medium': tabSize == 'medium'
  }">
  <div
    class="tabs__labels"
    [class.tabs__labels--center]="tabAlign === 'center'"
    (keyup.arrowright)="shiftTab(1)"
    (keyup.arrowleft)="shiftTab(-1)"
    role="tablist"
    #tabElements>
    <!-- Internal -->
    <button
      *ngFor="let tabItem of tabItems"
      (click)="handleTabSelect(tabItem)"
      class="tabs__label"
      [ngClass]="{
        'tabs__label--dark': tabTheme == 'dark',
        'tabs__label--light': tabTheme == 'light',
        'tabs__label--dark-active': tabTheme == 'dark' && isTabActive(tabItem),
        'tabs__label--light-active': tabTheme == 'light' && isTabActive(tabItem)
      }"
      [attr.aria-selected]="isTabActive(tabItem)"
      [attr.tabIndex]="isTabActive(tabItem) ? 0 : -1"
      role="tab"
      type="button"
      data-test="tabButton"
      #tabButton>
      {{ tabItem.label }}
    </button>
  </div>

  <div class="tabs__content">
    <ng-content></ng-content>
  </div>
</div>
